/*
 * Copyright (c) 2023. Haodong JU
 */

import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import hillo from 'hillo'
import { formatPrice } from '@/model/utils/formatPrice'

const entity = {
  startsAt: {},
  endsAt: {},
  sumDODCount: {
    displayName: 'TotalProductSales'
  },
  taxes: {
    displayName: 'TaxRate'
  },
  openCount: {
    displayName: 'orderCount'
  },
  closedCount: {
    displayName: 'orderFinishedCount'
  },
  sumTotal: {
    displayName: 'CashAmount',
    type: IKDataEntity.Types.Float
  }
}
const config = {

  load: async function (filter) {
    console.log(filter, 'filter')
    const [fromDate, toDate] = filter[0].dateFilter
    const res = (await hillo.get('BackendData.php?op=getHourlyReportV2', {
      fromDate,
      toDate
    })).content
    res.forEach(it => {
      it.taxes = it.taxes.map(it => (it.taxRate * 100).toFixed(2) + '%:' + formatPrice(it.sumTi)).join(' | ')
    })
    console.log(res, 'res')
    return res
  }

}

export default IKDataEntity.ModelFactory(entity, config)
